const AppTranslations = {
  notFound: {
    title: {
      key: 'app.notFound.title',
      default: 'Not Found - default',
    },
    content: {
      key: 'app.notFound.content',
      default:
        'The server returned a "404 Not Found". Try returning to your home page and try again. ',
    },
  },
};

const myElearningsTranslations = {
  warning: {
    unpublishedChanges: {
      key: 'myElearnings.warning.unpublishedChanges',
      default: 'Contains unpublished changes',
    },
  },
};

const quizTranslations = {
  error: {
    noCorrectAnswerMessage: `You haven't provided the correct answer to the quiz question. Select a
  choice and try again.`,
    compulsoryMessage:
      'Mandatory questions should not exceed number of questions asked',
  },
};

const elearningTranslations = {
  publish: {
    inProgressMessage: {
      key: 'elearning.publish.inProgressMessage',
      default: 'Publishing in progress',
    },
    inProgressInfo: {
      key: 'elearning.publish.inProgressInfo',
      default: 'This will take a moment. Please do not leave this page.',
    },
    successMessage: {
      key: 'elearning.publish.successMessage',
      default:
        'This module has been published to ::PUBLISH_TARGET:: successfully.',
    },
    actionMessage: {
      key: 'elearningPublish.publish.actionMessage',
      default: 'Publish to ::PUBLISH_TARGET::',
    },
    actionMessageCreateReview: {
      key: 'elearningPublish.publish.actionMessageCreateReview',
      default:
        'Publishing for Review will create a view-only copy that can be shared.\n' +
        '          Add reviewers to receive feedback and publish to ELMO Learning once\n' +
        '          you’re ready.',
    },
    actionMessageUpdateReview: {
      key: 'elearningPublish.publish.actionMessageUpdateReview',
      default:
        'Publishing will update the existing view-only copy of the Review. Once you are ready, you can publish the Review to ELMO Learning.',
    },
    actionMessageCreateLive: {
      key: 'elearningPublish.publish.actionMessageCreateLive',
      default:
        'Publishing will release the latest version of the Review. The module will be available to be included for course creations via ELMO Learning.',
    },
    actionMessageCreateMultitenantLive: {
      key: 'elearningPublish.publish.actionMessageCreateLive',
      default:
        'Publishing will release the latest version of the Review to your chosen subdomain. The module will be available as an ELMO module activity and can be used when creating courses.',
    },
    actionMessageMultiRegion: {
      key: 'elearningPublish.publish.actionMessageMultiRegion',
      default: 'Select the regions you want to publish this module to.',
    },
    multiRegionTitle: {
      key: 'elearningPublish.publish.multiRegionTitle',
      default: 'Publish to Other Regions',
    },
  },
};

const courseLibraryTranslations = {
  copyCourse: {
    inProgressTitle: {
      key: 'courseLibrary.copyCourse.inProgressTitle',
      default: 'Copy course is in progress',
    },
    inProgressInfo: {
      key: 'courseLibrary.copyCourse.inProgressInfo',
      default: 'This will take a moment. Please do not leave this page.',
    },
  },
};

const settingsTranslations = {
  Templates: {
    createTemplate: {
      Success: 'Create new template successful.',
      Fail: 'Create new template error! Something went wrong.',
    },
    deleteTemplate: {
      Success: 'Delete template successful.',
      Fail: 'Cannot delete the Template, it is used by some of your courses.',
    },
  },
};

export const Translations = {
  myElearnings: myElearningsTranslations,
  app: AppTranslations,
  quiz: quizTranslations,
  elearning: elearningTranslations,
  courseLibrary: courseLibraryTranslations,
  settings: settingsTranslations,
};
